<div class="modal-header">
    <span>{{ selectedPhoto.name }}</span>
</div>
<div class="modal-body">
    <img [src]="selectedPhoto.url">
</div>
<div class="modal-footer">
    <span (click)="close()" class="close-btn">Close</span>
</div>

